import { ArrowLeftOutlined } from '@ant-design/icons';
const ContentLibraryHeader = ({
  spanishTitle,
  showBackBtn,
  title,
  subtitle,
  description,
  color,
  extra,
  menu
}) => {
  return <div className="grade-resources-header" data-sentry-component="ContentLibraryHeader" data-sentry-source-file="ContentLibraryHeader.jsx">
      <div className="title-content">
        {showBackBtn ? <a onClick={() => history.back()}>
            <ArrowLeftOutlined /> Back
          </a> : null}
        <div className="title">{title && <span>{title}</span>} 
          {spanishTitle && <span className='secondary-title'>{spanishTitle}</span>}
        </div>
        <div className="sub-title">{subtitle}</div>
      </div>
      {description && <div className="description"> {description} </div>}
      {extra && <div className="extra-content">{extra}</div>}
      {menu && <div className="content-page-menu">{menu}</div>}
    </div>;
};
export default ContentLibraryHeader;